import { CircularProgress } from "@mui/material";
import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function SkeletonLoader({ height = 250 }) {
  return (
    <div className="d-flex flex-column gap-2">
      {[1, 2, 3].map((item, index) => (
        <div
          key={index}
          style={{
            width: "100%",
            maxWidth: "100%",
            padding: "0 10px",
          }}
        >
          <Skeleton
            baseColor="#ddd"
            highlightColor="#f5deb3"
            width="100%"
            height={height}
            style={{
              borderRadius: "10px",
            }}
          />
        </div>
      ))}
    </div>
  );
}
